interface ComputerWithLightSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithLightSVG = ({ color, style }: ComputerWithLightSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="51"
    viewBox="0 0 47 51"
    fill="none"
  >
    <g clipPath="url(#clip0_1477_5131)">
      <path
        d="M27.479 21.8991C28.0631 20.5956 29.1668 19.028 30.0816 17.4819C30.7817 16.2986 31.1854 14.9157 31.1854 13.4405C31.1854 8.92876 27.4231 5.29535 22.8642 5.50365C18.7584 5.69262 15.4406 9.05116 15.2989 13.1591C15.2366 14.9436 15.7649 16.6014 16.699 17.9543C17.7727 19.5069 18.9817 20.4925 19.4284 21.9957"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5443 24.1519V26.0051C26.5443 27.8304 25.0647 29.3099 23.2394 29.3099C21.4141 29.3099 19.9346 27.8304 19.9346 26.0051V24.1519H24.2015"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.0459 17.0181H39.1524C41.0336 17.0181 42.5604 18.5427 42.5604 20.426V43.9658"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.9209 43.9658V20.426C3.9209 18.5449 5.44556 17.0181 7.32883 17.0181H12.3559"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.543 20.166H39.187V41.5112"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2948 41.5112V20.166H14.291"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1761 44.2407C29.1761 45.4239 28.2162 46.3838 27.033 46.3838H21.6859C20.5027 46.3838 19.5428 45.4239 19.5428 44.2407H0.536133C0.536133 47.26 2.98417 49.7059 6.00342 49.7059H40.4778C43.4971 49.7059 45.943 47.2578 45.943 44.2407H29.1761Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0097 25.4443H15.4835C14.7328 25.4443 14.1242 26.0529 14.1242 26.8036V28.8673C14.1242 29.618 14.7328 30.2266 15.4835 30.2266H16.0097C16.7604 30.2266 17.369 29.618 17.369 28.8673V26.8036C17.369 26.0529 16.7604 25.4443 16.0097 25.4443Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.7938 25.4014V30.1836"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3555 25.4014V30.1836"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3125 34.1416V38.9239"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.4818 38.9668H28.0079C28.7586 38.9668 29.3672 38.3582 29.3672 37.6075V35.5438C29.3672 34.7931 28.7586 34.1845 28.0079 34.1845H27.4818C26.731 34.1845 26.1225 34.7931 26.1225 35.5438V37.6075C26.1225 38.3582 26.731 38.9668 27.4818 38.9668Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5267 38.9668H16.0528C16.8035 38.9668 17.4121 38.3582 17.4121 37.6075V35.5438C17.4121 34.7931 16.8035 34.1845 16.0528 34.1845H15.5267C14.776 34.1845 14.1674 34.7931 14.1674 35.5438V37.6075C14.1674 38.3582 14.776 38.9668 15.5267 38.9668Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0039 34.1416V38.9239"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4424 34.1416V38.9239"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9143 3.02979L29.4991 4.97748"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6574 9.55762L33.3661 10.3006"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8254 9.55762L13.1167 10.3006"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5675 3.02979L16.9848 4.97748"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2415 0.536621V2.94601"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1477_5131">
        <rect width="46.4827" height="50.2428" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithLightSVG;
